import React, { Component } from "react";
import { Link } from 'react-router-dom';

class Calculatedividend extends Component {
  render() {
    return (
      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="calculatedividend" className="a-breadcrumbs">วิธีการคำนวนเงินปันผล</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50">
                {/* section title*/}
                <h2 className="title-section mt-0 mb-0"><span>วิธีการคำนวนเงินปันผล</span></h2><br/>
                {/* ! section title*/}
                <div className="divider gray left mt-20 mb-25" />
                <img src="Img/Board/DevidendCalculate.jpg" />
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Calculatedividend;
